module.exports = __webpack_public_path__ + "static/media/product-premium-photo.6dcc2133.svg";